import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VacatureService } from 'src/app/services/vacature.service';

@Component({
  selector: 'app-vacature',
  templateUrl: './vacature.component.html',
  styleUrls: ['./vacature.component.sass']
})
export class VacatureComponent implements OnInit {

  vacId: any;
  vacature: any;

  constructor(private activatedRoute: ActivatedRoute, private vacatureService:VacatureService) { }

  ngOnInit(): void {

    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;

    this.vacId = params["vacature"];

    this.vacatureService.getVacature(this.vacId).subscribe(data => {
        this.vacature = this.vacatureService.populateVacature(data.data[0]);
    });
  }

}
